import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { FormGroupControl } from '@components/Base';
import { selectIsHospital } from '@components/Auth';
import { FormValues } from './schema';
import { selectCorporateHealthPolicyClaim } from './selector';

const GROUP_PROPS = { className: 'mb-3' };

const ContactInfoCardBody = () => {
  const { t } = useTranslation();
  const {
    values: { useMainContact },
  } = useFormikContext<FormValues>();
  const { user } = useSelector(selectCorporateHealthPolicyClaim);
  const isHospital = useSelector(selectIsHospital);
  const shouldShowUseMainContact = user?.relationshipType !== 'self' && !isHospital;

  return (
    <Card.Body>
      <Card.Title>{`Contact Information`}</Card.Title>
      {shouldShowUseMainContact && (
        <Row>
          <Col>
            <FormGroupControl
              type="checkbox"
              name="useMainContact"
              label={`Use contact of main insured person or policy holder`}
              bsPrefix="form-check-input"
              checked={useMainContact}
              groupProps={{ className: 'form-check form-check-inline mb-3' }}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <FormGroupControl
            required
            name="mobileNumber"
            label={t('user.mobileNumber')}
            groupProps={GROUP_PROPS}
            disabled={isHospital}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl name="email" label={t('user.email')} groupProps={GROUP_PROPS} disabled={isHospital} />
        </Col>
      </Row>
    </Card.Body>
  );
};

export { ContactInfoCardBody };
